import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IAccountTag, ResourceAutoCompleteViewModelType } from '../../../../../extViewmodels';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { AutoCompleteSearchField } from '../../../../../web/components/autocomplete/AutoCompleteSearchField';
import { SearchIcon } from '../../../../../web/components/svgs/icons/SearchIcon';
import { LeadRuleViewModel, LeadRulesViewModel, OwnershipEnforcement } from '../../../../viewModels/leadrules';
import { styleSheet } from '../styles';

interface IProps {
	leadRules: LeadRulesViewModel;
	onReadyToCreate: (rule: LeadRuleViewModel) => void;
}

export const BlitzesSearch: React.FC<IProps> = observer(({ onReadyToCreate }) => {
	const userSession = useUserSession();

	const handleSelection = (tag: IAccountTag) => {
		const newRule = new LeadRuleViewModel(userSession, {
			isEnabled: true,
			name: tag.name,
			ownershipEnforcement: OwnershipEnforcement.LeadVertical,
			preserve: false,
			priority: 300,
		});

		newRule.setFilterFromArrays([], [tag.name], [], []);
		onReadyToCreate(newRule);
	};

	return (
		<div className={css(styleSheet.inputContainer)}>
			<SearchIcon className={css(styleSheet.searchIcon)} fillColor='currentColor' />
			<div className={css(styleSheet.searchField)}>
				<AutoCompleteSearchField
					anchorClassName={css(styleSheet.input)}
					className={css(styleSheet.searchFieldRoot)}
					clearSearchFieldAfterSelectingItem={true}
					customQueryParams={{ excludeHidden: true }}
					dropdownContentClassName={css(styleSheet.resultsContainer)}
					initialSearchQuery=''
					inputId='blitz-tag-autcomplete'
					inputProps={{
						'aria-label': 'Search for a tag to add it as a Blitz',
						placeholder: 'Search for a tag to add it as a Blitz...',
					}}
					onItemSelected={handleSelection}
					resultsLimit={5}
					type={ResourceAutoCompleteViewModelType.AccountTag}
				/>
			</div>
		</div>
	);
});
